export default __webpack_public_path__ + "static/media/textcolor.59d148a7.svg";